import React from "react";
import AIModuleSubtopic from "../AIModuleSubtopic";

const UninformedSearchMethods = () => (
  <AIModuleSubtopic
    title="Uninformed Search Methods – Uniform Cost Search, Breadth First Search, Depth First Search, Depth-limited search, Iterative deepening depth-first"
    videos={[
      "https://www.youtube.com/embed/CfZUk6ldQ1k",
      "https://www.youtube.com/embed/cqE6WS2GFzA",
      "https://www.youtube.com/embed/GfgdWpgBJ0A",
      "https://www.youtube.com/embed/1t_JPXxUuC4",
      "https://www.youtube.com/embed/VOyWvwG5TB0",
      "https://www.youtube.com/embed/Ufbo1PNIhGE"
    ]}
    takeaways={[
      { text: "learn the advantages and disadvantages of different methods" },
      { text: "learn how one method overcome the disadvantages of the other" }
    ]}
    questions={[
      {
        text: "Apply the following search algorithms to find a path from the node A to G in the given graph: i) Depth First Search (DFS) ii) Depth-limited search (L=2) iii) Iterative Deepening Search (IDS) Note: Process the nodes alphabetically for the nodes at the same level. Also Analyze the above algorithms regarding completeness, optimality, time complexity, and space complexity",
        image:"/ai_5.png"
      },
      {
        text: "Consider the directed graph below, where a is the start node, and f is the goal node. Which sequences of paths are explored by BFS and DFS in this problem? Show the complete intermediate state space for DFS and BFS with a neat sketch. Would you prefer DFS or BFS for this problem? Justify? Note: Nodes are revisited as per the direction mentioned.",
        image:"/ai_6.png"
      },
      {
        text: "For the given directed graph (start node is S), perform the Uniform Cost Search (UCS). Expand the node based on the alphabetic order if the nodes have the same cumulative cost. 1. Show the priority queue and visited nodes for each step 2. Draw the tree for each step 3. Path and cost to reach the goal states (G1, G2, G3) 4. Find the goal node that has the minimum cost.",
        image:"/ai_7.png"
      },
      {
        text: "Trace the Breadth First Search Algorithm for the given tree structure and Compare its performance with the Depth Limited Search technique.",
        image:"/ai_8.png"
      },
      {
        text: "Consider a 5-city problem: Let's call VIT University (VU) and the 5 cities (C1), (C2),(C3), (C4) & (C5) respectively. A student starts from (VU), he/she visits 5 cities, and then returns back to (VU). Find the state-space representation of this problem. Also, compare DFS & BFS approaches for the given problem."
      },
      {
        text: "Consider the initial and the final state for an 8-puzzle problem given below. i. Generate all the states for the given problem ii. Find out the path to the final state using Breadth First Search (BFS) iii. Find out the path to the final state using Depth First Search (DFS)",
        image:"/ai_9.png"
      },
      
      {
        text: "i.Calculate the number of nodes generated in a depth-limited search to depth l with branching factor n. ii. Calculate the number of nodes generated in an iterative deepening search to depth l with branching factor b. iii. For n = 5, l = 10, suggest which one of the above two algorithms performs better. Justify the answer."
      },
      {
        text: "Consider the Water Jug problem as stated here: “You are given two jugs, a 4-gallon one and a 3-gallon one. Neither have any measuring markers on it. There is a pump that can be used to fill the jugs with water. How can you get exactly 2 gallons of water into the 4-gallon jug?” Represent this as a problem in State Space Search and state its Production Rules. Show at least one solution to this problem. Why is ‘depth limited search’ necessary in DFS?"
      },
      {
        text: "Consider the following graph. In what order will the nodes be visited using a (i) Breadth First Search and (ii) Depth First Search?",
        image:"/ai_10.png"
      },
      {
        text: "Demonstrate the uniform cost search algorithm by using the below graph. Find the minimum cost from node S to node G.",
        image:"/ai_11.png"
      },
      {
        text: "You are designing a search algorithm for a robot navigating a maze. Which search algorithm would be more suitable, Breadth-First Search or Depth-First Search? Justify your choice."
      }
    ]}
    exampleVideos={[]}
  />
);

export default UninformedSearchMethods;
